<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row" :class="maximize ? 'indicator-content-max' : 'indicator-content'">
		<div class="vx-col w-full md:w-1/4" v-show="!maximize">
			<vx-card no-shadow card-border :title="$t('Indicators.Indicators')">
				<vs-input icon-no-border :placeholder="$t('Search')" v-model="simpleSearchQuery" class="w-full mb-4" />
				<vue-perfect-scrollbar class="scroll-area" :settings="settings">
					<vx-card
						:key="indicator.id"
						v-for="indicator in indicators"
						:title="indicator.name | capitalize"
						title-color="primary"
						:subtitle="indicator.team_name"
						no-shadow
						card-border
						class="mb-4 cursor-pointer"
						@click.stop="openIndicator(indicator)"
					>
						<template slot="actions">
							<div class="flex flex-wrap justify-end">
								<feather-icon
									icon="EditIcon"
									class="ml-2"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="editData(indicator)"
								/>
								<feather-icon
									v-if="indicatorsDeletePermission"
									icon="Trash2Icon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="openConfirm(indicator.id)"
								/>
							</div>
						</template>
						<p class="font-semibold">{{ $t("Description") }}</p>
						<p>
							{{ indicator.description }}
						</p>
					</vx-card>
				</vue-perfect-scrollbar>
			</vx-card>
		</div>
		<div class="vx-col w-full" :class="maximize ? 'md:w-4/4' : 'md:w-3/4'">
			<vx-card
				no-shadow
				card-border
				:title="$t('Indicators.Visualizer')"
				class="indicator-content--iframe-content vs-con-loading__container"
				id="indicator-content--iframe-content"
			>
				<template slot="actions">
					<feather-icon
						:icon="maximize ? 'MinimizeIcon' : 'MaximizeIcon'"
						class="ml-2"
						svgClasses="w-5 h-5 hover:text-primary stroke-current"
						@click.stop="maximize = !maximize"
						:title="maximize ? $t('Minimize') : $t('Maximize')"
					/>
				</template>
				<i-frame
					:iframe="iframe"
					v-if="loaded"
					@iframeLoadedEmit="iframeLoaded"
					width="100%"
					:height="maximize ? 800 : 550"
				/>

				<div class="flex w-full bg-img mt-8" v-if="!loaded">
					<div
						class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
					>
						<img src="@/assets/images/pages/graphic-3.png" alt="graphic-graphic-3" class="mx-auto mb-4" />
						<h1 class="sm:mx-0 mx-4 sm:mb-5 mb-5 text-5xl d-theme-heading-color">
							{{ $t("Indicators.AlertVisualizar") }}
						</h1>
						<p class="sm:mx-0 mx-4 sm:mb-12 mb-5 text-primary">
							{{
								indicatorNotFounds
									? $t("Indicators.IndicatorNotFound")
									: $t("Indicators.AlertVisualizarInfo")
							}}
						</p>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
// models
import Indicator from "@/models/Indicator.js";
// Store
import moduleIndicator from "@/store/indicator/moduleIndicator.js";
import IFrame from "./Iframe.vue";

export default {
	components: {IFrame, VuePerfectScrollbar},
	data() {
		return {
			selected: null,
			itemsPerPage: 10,
			isMounted: false,
			dataId: null,
			activeAlert: true,
			loaded: false,
			iframe: {
				src: "",
				style: null,
				wrapperStyle: null,
				width: "100%",
				height: "550px",
				loaded: false,
			},
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			indicatorNotFounds: false,
			simpleSearchQuery: null,
			maximize: false,
		};
	},
	computed: {
		indicatorsDeletePermission() {
			return this.$store.getters.checkPermission("INDICATORS_D");
		},
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		indicators() {
			const data = !this.$store.state.moduleIndicator ? [] : this.$store.state.moduleIndicator.indicators;

			if (!this.simpleSearchQuery || this.simpleSearchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.simpleSearchQuery.toLowerCase()) ||
					r.team_name.toLowerCase().includes(this.simpleSearchQuery.toLowerCase())
				);
			});
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.indicators.length;
		},
		iframeSrc() {
			return this.src;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#indicator-content--iframe-content",
				scale: 0.45,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#indicator-content--iframe-content > .con-vs-loading");
		},
		addNewData() {
			this.$router.push({name: "app-indicator-create"});
		},
		openIndicator(data) {
			this.openLoadingContained();
			this.loaded = false;
			this.activeAlert = false;
			this.iframe.src = data.url;
			setTimeout(() => {
				this.loaded = true;
			}, 5000);
		},
		deleteData() {
			this.openLoading();
			this.$store
				.dispatch("moduleIndicator/removeIndicatorItem", this.dataId)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Indicators.TitleConfirmIndicatorDelete"),
						text: this.$t("Indicators.TextConfirmIndicatorDelete"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openConfirm(id) {
			this.dataId = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Indicators.DeleteIndicator"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.deleteData,
			});
		},
		editData(data) {
			this.$emit("selectedActivityEmit", new Indicator(data));
		},
		iframeLoaded() {
			this.closeLoadingContained();
		},
	},
	watch: {
		selected(val) {},
	},
	filters: {
		withForm(value) {
			if (value === 0 || !value) {
				return "Inactive";
			} else {
				return "Active";
			}
		},
	},
	created() {
		if (!moduleIndicator.isRegistered) {
			this.$store.registerModule("moduleIndicator", moduleIndicator);
			moduleIndicator.isRegistered = true;
		}

		if (this.$store.state.moduleIndicator.indicators.length <= 0) {
			this.openLoading();
			this.$store
				.dispatch("moduleIndicator/fetchIndicatorListItems")
				.then((res) => this.closeLoading())
				.catch((err) => {
					this.closeLoading();
					if (err) {
						if (err.status === 400 && err.message === "The requested resource doesn't exists") {
							this.indicatorNotFounds = true;
							this.$vs.notify({
								color: "primary",
								title: this.$t("Indicators.IndicatorList"),
								text: this.$t("Indicators.IndicatorNotFound"),
								icon: "info",
								time: 4000,
							});
						} else {
							this.$vs.notify({
								color: "warning",
								title: "Satus error : " + err.status,
								text: `${err.message}`,
							});
						}
					}
					console.error(err);
				});
		}
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss">
#data-indicators-list-view {
	.vs-con-table {
		min-height: 610px;
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.05);

				td {
					padding: 10px;

					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}

					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}

				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}

.indicator-content {
	height: 650px;
}
.indicator-content-max {
	height: 100vh;
}

.indicator-content--iframe-content {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 500px;
	max-height: 510px;
}
</style>
